import { render, staticRenderFns } from "./UsersEvaluations.vue?vue&type=template&id=011be6cb&"
import script from "./UsersEvaluations.vue?vue&type=script&lang=js&"
export * from "./UsersEvaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports